module.exports = __webpack_public_path__ + "5b5f28e2afef7a81fc98f2a94da579b6.svg";